/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M17.3231.2804c.3738-.3739.98-.3739 1.3538 0l5.0427 5.0427a.9572.9572 0 0 1 0 1.3538l-5.0427 5.0427a.9572.9572 0 0 1-1.3538 0l-5.0427-5.0427a.9572.9572 0 0 1 0-1.3538L17.3231.2804ZM0 1.5c0-.5523.4477-1 1-1h9c.5523 0 1 .4477 1 1v9c0 .5523-.4477 1-1 1H1c-.5523 0-1-.4477-1-1v-9ZM1.5 10V2h8v8h-8ZM0 14c0-.5523.4477-1 1-1h9c.5523 0 1 .4477 1 1v9c0 .5523-.4477 1-1 1H1c-.5523 0-1-.4477-1-1v-9ZM13.5 13c-.5523 0-1 .4477-1 1v9c0 .5523.4477 1 1 1h9c.5523 0 1-.4477 1-1v-9c0-.5523-.4477-1-1-1h-9Zm.5 1.5v8h8v-8h-8Z"
    clipRule="evenodd"
  />,
  'MenuHelmFilled'
);
